import React from "react";
import { useAppSelector } from "../app/hooks";
import AppDrawer from "../components/muidrawer/Drawer";
import CreateMenu from "./menu/CreateMenu";
import CreateRights from "./rights/CreateRights";
import CreateCMS from "./cms/CreateCMS";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateClientLogo from "./clientlogo/CreateClientLogo";
import CreateGallary from "./gallary/CreateGallary";
import CreateTeamMember from "./teammember/CreateTeamMember";
import CreateContact from "./inquiries/CreateContacts";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.muidrawer.open);
  const drawerName = useAppSelector((state) => state.muidrawer.name);

  //   ***********Note : Here you need to add key as a form name same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    cmsForm: <CreateCMS />,
    menuForm: <CreateMenu />,
    rightsForm: <CreateRights />,
    testimonialForm: <CreateTestimonial />,
    clientLogoForm: <CreateClientLogo />,
    gallaryForm: <CreateGallary />,
    teamMemberForm: <CreateTeamMember />,
    contactsForm: <CreateContact />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
